import { AfterViewInit, Component, ElementRef, Input, OnInit } from '@angular/core';
import { UntypedFormControl, FormGroupDirective } from '@angular/forms';

@Component({
  selector: 'app-textarea',
  templateUrl: './app-textarea.component.html',
  styleUrls: ['./app-textarea.component.scss']
})
export class AppTextareaComponent implements OnInit, AfterViewInit {

  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  control: UntypedFormControl;

  @Input()
  id: string;

  @Input()
  label: string;

  @Input()
  maxCharCount = 200;

  showInfo = false;
  maxCharCountExceeded = false;

  constructor(private el: ElementRef) { }

  ngOnInit(): void {
    if (this.control.value) {
      this.countCharsAndTrim();
    }
  }

  ngAfterViewInit() {
    const textarea = this.el.nativeElement.querySelector('textarea');
    // Wird nur bei druckbaren Zeichen ausgelöst
    textarea.addEventListener('keypress', (event) => {
      // Es wird davon ausgegangen dass das Zeichen hinzugefügt wird, ein Ersetzen des Zeichens mit markierten Zeichen ist nicht möglich
      if (textarea.value.length + 1 > this.maxCharCount) {
        // Verhindere die Eingabe des Zeichens
        event.preventDefault();
        this.maxCharCountExceeded = true;
      }
    });
    textarea.addEventListener('keydown', () => {
      // Lösche die Copy-Paste Info bei jedem Key event
      this.showInfo = false;
      this.maxCharCountExceeded = false;
    });
    textarea.addEventListener('paste', () => {
      // Es wird der aktuelle (endgültige) Wert benötigt, deshalb die asynchrone Ausführung
      setTimeout(() => {
        this.countCharsAndTrim();
      });
    });
  }

  get charCounter(): number {
    const charCounter = this.maxCharCount - (this.control.value?.length ?? 0);
    return charCounter < 0 ? 0 : charCounter;
  }

  countCharsAndTrim(): void {
    this.showInfo = false;
    this.maxCharCountExceeded = false;
    if (this.control.value?.length > this.maxCharCount) {
      this.control.setValue(this.control.value.substring(0, this.maxCharCount), { emitEvent: false });
      this.showInfo = true;
      this.maxCharCountExceeded = true;
    }
  }

  setValue(value: string) {
    this.control.setValue(value);
    this.countCharsAndTrim();
  }
}
